import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { AppLayout } from "@/components/AppLayout";
import { isEmbedMode } from "@/utils/embed";
// import { PostHogDebug } from "@/components/posthog-debug";

function App() {
  const { loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full size-12 border-b-2 border-primary"></div>
          <p className="text-muted-foreground">Loading...</p>
          {/* <PostHogDebug /> */}
        </div>
      </div>
    );
  }

  // Check if current route is an auth route
  const isAuthRoute = [
    "/login",
    "/register",
    "/forgot-password",
    "/auth/login",
    "/auth/register",
    "/auth/forgot-password",
    "/auth/reset-password",
    "/auth/initiate-unified-signin",
  ].includes(location.pathname);

  // Check if current route should be in embed mode
  const isEmbedRoute = isEmbedMode();

  // For auth routes or embed routes, don't use the sidebar layout
  if (isAuthRoute || isEmbedRoute) {
    return (
      <div className="min-h-screen bg-background">
        <Outlet />
        <Toaster position="top-right" closeButton richColors />
        {/* <PostHogDebug /> */}
      </div>
    );
  }

  // For all other routes, use the sidebar layout
  return (
    <AppLayout>
      <Outlet />
      <Toaster position="top-right" closeButton richColors />
      {/* <PostHogDebug /> */}
    </AppLayout>
  );
}

export default App;
